module.exports = __webpack_public_path__ + "pc/img/modal_24.6e1fa039.png";